// Hook odrzucenia oferty przez klienta - PUT /sales-crm/my-offers/:id/reject

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPutSalesCrmMyOfferRejectPayload {
  reason?: string | null;
}

const putSalesCrmMyOfferReject = (
  offerId: string | number,
  payload: IPutSalesCrmMyOfferRejectPayload
): Promise<ICommandResponseSuccess> =>
  axios.put(`/sales-crm/my-offers/${offerId}/reject`, payload);

export const usePutSalesCrmMyOfferReject = (
  offerId: string | number,
  options?: UseMutationOptions<
    ICommandResponseSuccess,
    IError,
    IPutSalesCrmMyOfferRejectPayload
  >
) =>
  useMutation(
    (payload: IPutSalesCrmMyOfferRejectPayload) => putSalesCrmMyOfferReject(offerId, payload),
    options
  );
